import React from 'react';
import DrinkIcon from '../../../../../icons/drink-icon';
import WifiIcon from '../../../../../icons/wifi-icon';
import TvIcon from '../../../../../icons/tv-icon';
import TerraceIcon from '../../../../../icons/terrace-icon';
import SpaIcon from '../../../../../icons/spa-icon';
import ReceptionIcon from '../../../../../icons/reception-icon';
import PoolIcon from '../../../../../icons/pool-icon';
import DartsIcon from '../../../../../icons/darts-icon';
import BusIcon from '../../../../../icons/bus-icon';
import UmbrellaIcon from '../../../../../icons/umbrella-icon';
import GymIcon from '../../../../../icons/gym-icon';
import SafeIcon from '../../../../../icons/safe-icon';
import AirIcon from '../../../../../icons/air-icon';
import ElevatorIcon from '../../../../../icons/elevator-icon';

export default class FacilitiesOffers extends React.Component {
  render() {
    const { facilities } = this.props;

    return (
      <div className="wrapper-facilitie">
        {facilities.map((facilitie, index) => {
          const icon = this.getFacilitiesIcon(facilitie.type);
          return icon ? (
            <span className="facilitie-icon" key={index}>
              {icon}
            </span>
          ) : null;
        })}
      </div>
    );
  }

  getFacilitiesIcon = type => {
    switch (type) {
      case 'bar':
        return <DrinkIcon />;
      case 'wifi':
        return <WifiIcon />;
      case 'tvroom':
        return <TvIcon />;
      case 'terrace':
        return <TerraceIcon />;
      case 'spa':
        return <SpaIcon />;
      case 'reception':
        return <ReceptionIcon />;
      case 'pool':
        return <PoolIcon />;
      case 'darts':
        return <DartsIcon />;
      case 'transfer':
        return <BusIcon />;
      case 'parasols':
        return <UmbrellaIcon />;
      case 'safe':
        return <SafeIcon />;
      case 'gym':
        return <GymIcon />;
      case 'aircon':
        return <AirIcon />;
      case 'elevators':
        return <ElevatorIcon />;
      default:
        return null;
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/facilities.jsx